<template>
  <b-overlay
    v-if="overlay"
    id="content-container"
    :show="overlay"
    rounded="lg"
    :opacity="1"
    no-fade
    variant="white"
    class="vh50"
  >
    <slot></slot>
  </b-overlay>
  <div
    v-else
    id="content-container"
    class="vh50"
    :class="{ 'container': container, 'mb-5': !noBottomMargin }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ContentContainer",
  props: {
    overlay: {
      default: false,
    },
    container: {
      type: Boolean,
      default: true,
    },
    noBottomMargin: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
#content-container {
  flex: 1;
}
</style>